import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  checkNameIsNotAPrimitive28vmhppr4nskt as checkNameIsNotAPrimitive,
  PrimitiveDescriptorSafe1r3pht5v1oaqu as PrimitiveDescriptorSafe,
} from '../internal/Primitives.mjs';
import {
  PrimitiveKindndgbuh6is7ze as PrimitiveKind,
  CLASS_getInstance25nhr3t715wdo as CLASS_getInstance,
} from './SerialKinds.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toList383f556t1dixk as toList,
  withIndex3s8q7w1g0hyfn as withIndex,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  toStringImpl1y3u8fza7vdq as toStringImpl,
  hashCodeImplfv8qiy3re24s as hashCodeImpl,
} from '../internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
} from './SerialDescriptor.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  toHashSet1qrcsl3g8ugc8 as toHashSet,
  toBooleanArray2u3qw7fjwsmuh as toBooleanArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { copyToArray2j022khrow2yi as copyToArray } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { compactArray1b2nl9rkq8nuz as compactArray } from '../internal/Platform.common.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { toMap1vec9topfei08 as toMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  getChecked1o70dkx10jwym as getChecked,
  getChecked3avs2psuwt1xd as getChecked_0,
} from '../internal/Platform.mjs';
import { contentEqualsaf55p28mnw74 as contentEquals } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { CachedNames2minxlyafeo07 as CachedNames } from '../internal/CachedNames.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function SerialDescriptor_0(serialName, original) {
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException().n2(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!!(serialName === original.k1n())) {
    var message_0 = 'The name of the wrapped descriptor (' + serialName + ') cannot be the same as the name of the original descriptor (' + original.k1n() + ')';
    throw IllegalArgumentException().n2(toString(message_0));
  }
  var tmp = original.d1p();
  if (tmp instanceof PrimitiveKind()) {
    checkNameIsNotAPrimitive(serialName);
  }
  return new (WrappedSerialDescriptor())(serialName, original);
}
function PrimitiveSerialDescriptor(serialName, kind) {
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException().n2(toString(message));
  }
  return PrimitiveDescriptorSafe(serialName, kind);
}
function buildClassSerialDescriptor(serialName, typeParameters, builderAction) {
  var tmp;
  if (builderAction === VOID) {
    tmp = buildClassSerialDescriptor$lambda;
  } else {
    tmp = builderAction;
  }
  builderAction = tmp;
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException().n2(toString(message));
  }
  var sdBuilder = new (ClassSerialDescriptorBuilder())(serialName);
  builderAction(sdBuilder);
  return new (SerialDescriptorImpl())(serialName, CLASS_getInstance(), sdBuilder.v1m_1.q2(), toList(typeParameters), sdBuilder);
}
var ClassSerialDescriptorBuilderClass;
function ClassSerialDescriptorBuilder() {
  if (ClassSerialDescriptorBuilderClass === VOID) {
    class $ {
      constructor(serialName) {
        this.s1m_1 = serialName;
        this.t1m_1 = false;
        this.u1m_1 = emptyList();
        this.v1m_1 = ArrayList().p2();
        this.w1m_1 = HashSet().ga();
        this.x1m_1 = ArrayList().p2();
        this.y1m_1 = ArrayList().p2();
        this.z1m_1 = ArrayList().p2();
      }
      s1p(elementName, descriptor, annotations, isOptional) {
        // Inline function 'kotlin.require' call
        if (!this.w1m_1.i2(elementName)) {
          var message = "Element with name '" + elementName + "' is already registered in " + this.s1m_1;
          throw IllegalArgumentException().n2(toString(message));
        }
        // Inline function 'kotlin.collections.plusAssign' call
        this.v1m_1.i2(elementName);
        // Inline function 'kotlin.collections.plusAssign' call
        this.x1m_1.i2(descriptor);
        // Inline function 'kotlin.collections.plusAssign' call
        this.y1m_1.i2(annotations);
        // Inline function 'kotlin.collections.plusAssign' call
        this.z1m_1.i2(isOptional);
      }
      a1n(elementName, descriptor, annotations, isOptional, $super) {
        annotations = annotations === VOID ? emptyList() : annotations;
        isOptional = isOptional === VOID ? false : isOptional;
        var tmp;
        if ($super === VOID) {
          this.s1p(elementName, descriptor, annotations, isOptional);
          tmp = Unit_instance;
        } else {
          tmp = $super.s1p.call(this, elementName, descriptor, annotations, isOptional);
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'ClassSerialDescriptorBuilder');
    ClassSerialDescriptorBuilderClass = $;
  }
  return ClassSerialDescriptorBuilderClass;
}
function buildSerialDescriptor(serialName, kind, typeParameters, builder) {
  var tmp;
  if (builder === VOID) {
    tmp = buildSerialDescriptor$lambda;
  } else {
    tmp = builder;
  }
  builder = tmp;
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException().n2(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!!equals(kind, CLASS_getInstance())) {
    var message_0 = "For StructureKind.CLASS please use 'buildClassSerialDescriptor' instead";
    throw IllegalArgumentException().n2(toString(message_0));
  }
  var sdBuilder = new (ClassSerialDescriptorBuilder())(serialName);
  builder(sdBuilder);
  return new (SerialDescriptorImpl())(serialName, kind, sdBuilder.v1m_1.q2(), toList(typeParameters), sdBuilder);
}
var WrappedSerialDescriptorClass;
function WrappedSerialDescriptor() {
  if (WrappedSerialDescriptorClass === VOID) {
    class $ {
      constructor(serialName, original) {
        this.t1p_1 = serialName;
        this.u1p_1 = original;
      }
      k1n() {
        return this.t1p_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof WrappedSerialDescriptor()))
          return false;
        return this.t1p_1 === other.t1p_1 && equals(this.u1p_1, other.u1p_1);
      }
      hashCode() {
        var result = getStringHashCode(this.t1p_1);
        result = imul(31, result) + hashCode(this.u1p_1) | 0;
        return result;
      }
      toString() {
        return toStringImpl(this);
      }
      d1p() {
        return this.u1p_1.d1p();
      }
      w1o() {
        return this.u1p_1.w1o();
      }
      e1p() {
        return this.u1p_1.e1p();
      }
      f1p() {
        return this.u1p_1.f1p();
      }
      g1p() {
        return this.u1p_1.g1p();
      }
      h1p(index) {
        return this.u1p_1.h1p(index);
      }
      i1p(name) {
        return this.u1p_1.i1p(name);
      }
      j1p(index) {
        return this.u1p_1.j1p(index);
      }
      k1p(index) {
        return this.u1p_1.k1p(index);
      }
      l1p(index) {
        return this.u1p_1.l1p(index);
      }
    }
    initMetadataForClass($, 'WrappedSerialDescriptor', VOID, VOID, [SerialDescriptor()]);
    WrappedSerialDescriptorClass = $;
  }
  return WrappedSerialDescriptorClass;
}
function _get__hashCode__tgwhef($this) {
  var tmp0 = $this.g1q_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('_hashCode', 1, tmp, SerialDescriptorImpl$_get__hashCode_$ref_2v7wzp(), null);
  return tmp0.n3();
}
function SerialDescriptorImpl$_get__hashCode_$ref_2v7wzp() {
  return (p0) => _get__hashCode__tgwhef(p0);
}
var SerialDescriptorImplClass;
function SerialDescriptorImpl() {
  if (SerialDescriptorImplClass === VOID) {
    class $ {
      constructor(serialName, kind, elementsCount, typeParameters, builder) {
        this.v1p_1 = serialName;
        this.w1p_1 = kind;
        this.x1p_1 = elementsCount;
        this.y1p_1 = builder.u1m_1;
        this.z1p_1 = toHashSet(builder.v1m_1);
        var tmp = this;
        // Inline function 'kotlin.collections.toTypedArray' call
        var this_0 = builder.v1m_1;
        tmp.a1q_1 = copyToArray(this_0);
        this.b1q_1 = compactArray(builder.x1m_1);
        var tmp_0 = this;
        // Inline function 'kotlin.collections.toTypedArray' call
        var this_1 = builder.y1m_1;
        tmp_0.c1q_1 = copyToArray(this_1);
        this.d1q_1 = toBooleanArray(builder.z1m_1);
        var tmp_1 = this;
        // Inline function 'kotlin.collections.map' call
        var this_2 = withIndex(this.a1q_1);
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().h2(collectionSizeOrDefault(this_2, 10));
        var _iterator__ex2g4s = this_2.p1();
        while (_iterator__ex2g4s.q1()) {
          var item = _iterator__ex2g4s.r1();
          var tmp$ret$4 = to(item.ck_1, item.bk_1);
          destination.i2(tmp$ret$4);
        }
        tmp_1.e1q_1 = toMap(destination);
        this.f1q_1 = compactArray(typeParameters);
        var tmp_2 = this;
        tmp_2.g1q_1 = lazy(() => hashCodeImpl(this, this.f1q_1));
      }
      k1n() {
        return this.v1p_1;
      }
      d1p() {
        return this.w1p_1;
      }
      f1p() {
        return this.x1p_1;
      }
      g1p() {
        return this.y1p_1;
      }
      h1q() {
        return this.z1p_1;
      }
      h1p(index) {
        return getChecked(this.a1q_1, index);
      }
      i1p(name) {
        var tmp0_elvis_lhs = this.e1q_1.u4(name);
        return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
      }
      j1p(index) {
        return getChecked(this.c1q_1, index);
      }
      k1p(index) {
        return getChecked(this.b1q_1, index);
      }
      l1p(index) {
        return getChecked_0(this.d1q_1, index);
      }
      equals(other) {
        var tmp$ret$0;
        $l$block_5: {
          // Inline function 'kotlinx.serialization.internal.equalsImpl' call
          if (this === other) {
            tmp$ret$0 = true;
            break $l$block_5;
          }
          if (!(other instanceof SerialDescriptorImpl())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!(this.k1n() === other.k1n())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!contentEquals(this.f1q_1, other.f1q_1)) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!(this.f1p() === other.f1p())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          var inductionVariable = 0;
          var last = this.f1p();
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              if (!(this.k1p(index).k1n() === other.k1p(index).k1n())) {
                tmp$ret$0 = false;
                break $l$block_5;
              }
              if (!equals(this.k1p(index).d1p(), other.k1p(index).d1p())) {
                tmp$ret$0 = false;
                break $l$block_5;
              }
            }
             while (inductionVariable < last);
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      hashCode() {
        return _get__hashCode__tgwhef(this);
      }
      toString() {
        return toStringImpl(this);
      }
    }
    protoOf($).w1o = get_isNullable;
    protoOf($).e1p = get_isInline;
    initMetadataForClass($, 'SerialDescriptorImpl', VOID, VOID, [SerialDescriptor(), CachedNames()]);
    SerialDescriptorImplClass = $;
  }
  return SerialDescriptorImplClass;
}
function buildClassSerialDescriptor$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function buildSerialDescriptor$lambda(_this__u8e3s4) {
  return Unit_instance;
}
//region block: exports
export {
  PrimitiveSerialDescriptor as PrimitiveSerialDescriptor3egfp53lutxj2,
  SerialDescriptor_0 as SerialDescriptorbzxbhtn690r4,
  buildClassSerialDescriptor as buildClassSerialDescriptors2a6xdp6mrtw,
  buildSerialDescriptor as buildSerialDescriptor2873qmkp8r2ib,
};
//endregion

//# sourceMappingURL=SerialDescriptors.mjs.map
